import _taggedTemplateLiteral from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { typography } from "../../shared/constants";
export var H2 = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  ", ";\n"])), typography.type.nexa, typography.h2Text);